<template>
  <div :style="style" @click.capture="handleWrapperClick">
    <slot></slot>
  </div>
</template>

<script>
/**
 * 在端外：点击跳转linkme页面，唤醒app
 * 在端内：未登录时，跳转app登录页面
 */
import authStore from '@/store/auth';
import { LOGIN } from '@/utils/consts/app-page';
import { getNavigatorToParams } from '@/utils/helpers/page-dictionary';

export default {
  name: 'ClickEventWrapper',
  props: {
    display: {
      type: String,
      default: 'inline-block',
    },
    awaken: {
      type: [Object, Boolean],
      default: true,
    },
    /**
     * 默认为当前路由，或者指定h5路由
     * route的格式
     *  {
     *    name: '路由name'
     *    params: {
     *      id: 'XXXID'
     *    }
     *  }
     */
    route: {
      type: Object,
      default() {
        return this.$route;
      },
    },
    login: {
      type: Boolean,
      default: true,
    },
    params: {
      type: Object,
    },
  },
  computed: {
    style() {
      const { display } = this;
      return {
        display,
      };
    },
    needAwaken() {
      return this.awaken !== false;
    },
    needLogin() {
      return this.login !== false;
    },
    isInApp() {
      return this.$bridge.device.swjApp;
    },
  },
  methods: {
    getAwakenParams() {
      return this.getNavigatorToParams(this.route);
    },
    handleWrapperClick(event) {
      // 在app端外，需唤醒app
      let awakenParams;
      if (this.needAwaken && !this.isInApp) {
        if (this.params) {
        // 1、如果端外传入params，则用params作为唤醒app的入参，
          awakenParams = this.params;
        } else {
          // 2、使用当前路由，则根据路由映射表找到对应的app字典作为入参
          awakenParams = getNavigatorToParams(this.route);
          if (typeof this.awaken !== 'boolean') {
            awakenParams = this.awaken;
          }
        }

        this.$sensors.quick('trackHeatMap', event.target);
        if (this.params) {
          this.$linkedme.awaken(awakenParams);
        } else {
          // 增加额外的路由模块参数
          this.$linkedme.awaken(awakenParams.result, { state: 0, ...awakenParams.options });
        }
        event.stopImmediatePropagation();
      }
      // 在app内，需登录app
      if (this.needLogin && this.isInApp) {
        if (!authStore.state.accessToken) {
          this.$sensors.quick('trackHeatMap', event.target);
          this.$bridge.navigateTo({ name: LOGIN });
          event.stopImmediatePropagation();
        }
      }
    },
  },
};
</script>
